import BASE_URL from '../config/apiConfig';

export const ExpenseService = {
  // Function to get the auth token from session storage
  getAuthToken() {
    return sessionStorage.getItem('jwt');
  },

  async fetchExpensesByProperty(propertyId: any) {
    const token = this.getAuthToken();
    try {
      const response = await fetch(`${BASE_URL}Expense/${propertyId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch tenants');
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching tenants:', error);
      throw error;
    }
  },

  // Add or update property data (POST)
  async postExpense(expenseData: any) {
    const token = this.getAuthToken();
    try {
      const response = await fetch(`${BASE_URL}Expense/AddExpense`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token && { Authorization: `Bearer ${token}` }),
        },
        body: JSON.stringify(expenseData),
      });
      if (!response.ok) {
        throw new Error('Failed to create/update expense');
      }

      return await response.json();
    } catch (error) {
      console.error('Error posting expense:', error);
      throw error;
    }
  },

  async updateExpense(expenseData: any) {
    const token = this.getAuthToken();
    try {
      const response = await fetch(
        `${BASE_URL}Expense/${expenseData.expenseId}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            ...(token && { Authorization: `Bearer ${token}` }),
          },
          body: JSON.stringify(expenseData),
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to update expense: ${errorText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error updating expense:', error);
      throw error;
    }
  },
};
